import { SegmentedControl } from '@mantine/core'

import styles from './FilterPicker.module.css'

export type FilterOptions = 'open' | 'resolved'

export const FilterPicker = ({
  filter,
  setFilter,
}: {
  filter: FilterOptions
  setFilter: (value: FilterOptions) => void
}) => (
  <SegmentedControl
    classNames={{
      control: styles.control,
      indicator: styles.indicator,
      root: styles.root,
    }}
    value={filter}
    data={[
      {
        value: 'open',
        label: 'Open',
      },
      {
        value: 'resolved',
        label: 'Resolved',
      },
    ]}
    onChange={(value) => {
      setFilter(value === 'open' ? 'open' : 'resolved')
    }}
  />
)
